import React from 'react';

const TermsAndConditions = () => {
  return (
    <div className="min-h-screen bg-gray-50 py-8 px-4 sm:px-6 lg:px-8">
      <div className="max-w-3xl mx-auto bg-white rounded-lg shadow-sm">
        <div className="p-6 space-y-6">
          <h1 className="text-3xl font-bold text-center text-gray-900 mb-8">
            CitiBargain Terms & Conditions
          </h1>

          <div className="space-y-4 text-gray-700">
            <p>
              These Terms and Conditions ("Terms") govern your use of the CitiBargain mobile application ("App"), owned and operated by Caresgate Africa Ltd ("Company,"), a company registered in Nigeria. By accessing or using our App, you agree to comply with these Terms.
            </p>

            <p className="font-medium">
              Please read them carefully.
            </p>

            <div>
              <h2 className="font-semibold text-lg text-gray-900 mb-2">1. Introduction</h2>
              <p>
                CitiBargain is a mobile e-commerce platform designed for retailers in Nigeria to purchase Fast-Moving Consumer Goods (FMCG). Caresgate Africa Ltd manages the fulfillment, logistics, and delivery of orders, which are typically completed within 24 to 36 hours.
              </p>
            </div>

            <div>
              <h2 className="font-semibold text-lg text-gray-900 mb-2">2. Eligibility</h2>
              <p>
                To use the CitiBargain App, you must:
                <ul className="list-disc pl-5 mt-2">
                  <li>Be a retailer or business operating in Nigeria</li>
                  <li>Be at least 18 years of age</li>
                  <li>Provide valid and verifiable business details, such as Business address, Phone number, and contact details</li>
                </ul>
              </p>
            </div>

            <div>
              <h2 className="font-semibold text-lg text-gray-900 mb-2">3. Account Registration</h2>
              <p>
                You are required to create an account by providing accurate business information, including a valid phone number. You are responsible for maintaining the confidentiality of your account credentials. You must promptly update your account information if there are changes to your business details.
              </p>
            </div>

            <div>
              <h2 className="font-semibold text-lg text-gray-900 mb-2">4. Placing Orders</h2>
              <p>
                Orders can be placed via the App, subject to product availability. All orders are final once confirmed, and can be modified or cancelled 12 hours before scheduled delivery as advised upon placing of your order on the app. Bulk purchases are mandatory, and the App displays minimum order quantities for each product.
              </p>
            </div>

            <div>
              <h2 className="font-semibold text-lg text-gray-900 mb-2">5. Pricing and Payments</h2>
              <p>
                All prices displayed on CitiBargain are exclusive of taxes, unless otherwise stated. Payment is required at the time of order delivery, via our online transfer of Cash payment system. Payments are non-refundable unless a valid return or refund request is approved under our Return Policy.
              </p>
            </div>

            <div>
              <h2 className="font-semibold text-lg text-gray-900 mb-2">6. Fulfillment and Delivery</h2>
              <p>
                We manage the fulfillment, logistics, and delivery of all orders. Deliveries are typically completed within 24 to 36 hours of order confirmation. Delivery timeframes are estimates and may vary based on location, product availability, and other factors beyond our control.
              </p>
            </div>

            <div>
              <h2 className="font-semibold text-lg text-gray-900 mb-2">7. Returns and Refunds</h2>
              <p>
                Defective, damaged, or incorrect products may be eligible for return or refund within 24 hours of receipt. You must notify us of any issues and provide supporting evidence, such as photos, within the specified period.
              </p>
            </div>

            <div>
              <h2 className="font-semibold text-lg text-gray-900 mb-2">8. Contact Information</h2>
              <p>
                For questions, feedback, or issues related to these Terms or the CitiBargain App, please contact us at:
                <br />
                Email: admin@caresgateafrica.com
                <br />
                Phone: +234 816 846 9043
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TermsAndConditions;